import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", as = "div", hoverLift = false }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      whileHover={hoverLift ? { y: -6 } : undefined}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.45, ease: "easeOut", delay }}
    >
      {children}
    </MotionTag>
  );
}
